import {call, put} from 'redux-saga/effects';
import DealersActions from '../redux/DealersRedux';
import MessagesActions from '../redux/MessagesRedux';

export function * getDealers(api, action) {
  const response = yield call(api.getDealers, {...action.props});

  if (response.ok) {
    yield put(DealersActions.dealersSuccess({...response.data, ...action.props}));
  } else {
    yield put(DealersActions.dealersFailure(response.data && response.data.title ? response.data.title : response.problem));
    yield put(MessagesActions.messagesShow({type: 'error', code: response.status, title: response.data && response.data.title ? response.data.title : response.problem}));
  }
}
